import { Box, Modal } from '@wishket/design-system';

import {
  GrassInfoModalTitle,
  GrassInfoModalBody,
} from './GrassInfoModal.parts';

interface GrassInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  isDesktop: boolean;
}

const GrassInfoModal = ({
  isOpen,
  onClose,
  isDesktop,
}: GrassInfoModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      variant={isDesktop ? 'default' : 'bottom'}
      isPreventScroll
    >
      <Box className="flex h-[calc(100%_-_32px)] w-full flex-col gap-8 pb-5 desktop:max-h-[90vh] desktop:py-8">
        {isDesktop && <GrassInfoModalTitle onClose={onClose} />}
        <GrassInfoModalBody />
      </Box>
    </Modal>
  );
};

export default GrassInfoModal;
